import styled from "styled-components";

export const Container = styled.div``;

export const HeaderWrapper = styled.div`
  .text-body {
    :hover {
      border-bottom: 1px solid;
    }
  }
  & h1 {
    word-break: keep-all;
    @media screen and (max-width: 991px) {
      font-size: 42px;
    }
    @media screen and (max-width: 767px) {
      font-size: 36px;
    }
  }
`;

export const HeaderMeta = styled.div`
  .entry-meta {
    width: 100%;
    font-size: 0.9rem;
    display: flex;
    justify-content: space-between;
  }
  .meta-left {
    display: flex;
    align-items: center;
  }
  .meta-right {
    display: flex;
    align-items: center;
    & li {
      cursor: pointer;
      color: #6c757d !important;
      :hover {
        color: #198754 !important;
      }
    }
    & li:not(:last-of-type) {
      margin-right: 10px;
    }
  }
`;

export const ContentsWrapper = styled.div`
  .single-excerpt {
    word-break: keep-all;
  }
`;

export const Thumbnail = styled.figure`
  width: 100%;
  min-height: 400px;
  max-height: 600px;
  border-radius: 30px;
  background: center / contain no-repeat url(${(props) => props.thumbnail});
`;

export const EditorWrapper = styled.div`
  max-width: 100%;
`;

export const RecomandList = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;

  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 575px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
